import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { ObjectType } from "./object-type";
import { ObjectClass } from "./object-class";
import { DbIngestConfigPackPlaceholderRowFieldInfos } from "./db-ingest-config-pack-placeholder-row-field-infos";

export class DbIngestConfigPackPlaceholderRowInfos extends DbMongoSerializationBaseInfos {
  isOptionnal: boolean = false;
  packId: number | null = 0;
  objectType: ObjectType | null = null;
  lastUpdate: Date | null = new Date("2022-09-27T14:41:34.0773214+02:00");
  name: string | null = null;
  description: string | null = null;
  objectClasses: ObjectClass[] | null = null;
  fields: DbIngestConfigPackPlaceholderRowFieldInfos[] | null = null;
  uploadableFileFormatIds: number[] | null = null;
  isSelected: boolean | null = null;

  constructor(init?: Partial<DbIngestConfigPackPlaceholderRowInfos>) {
    super();
    Object.assign(this, init);
  }
}

export interface PlaceholderNameDto {
  id: number;
  name: string;
}

export interface NewRequestRow {
  id: number;
  originalPlaceholderId: number;
  placeHolderName: string;
  isOptionnal: boolean;
  isOutdated: boolean;
}
